import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	unassignedDisplayName: {
		id: 'issue-table-grouping.group-row.group-header.assignee-group-header.unassigned-display-name',
		defaultMessage: 'Unassigned',
		description:
			'Text used as a group name for unassigned issues when grouping items by assignee is enabled.',
	},
	noUserDisplayName: {
		// TODO: [JSC-2233] remove nonfinal suffix after confirming with CD
		id: 'issue-table-grouping.group-row.group-header.user-group-header.no-user-display-name-nonfinal',
		defaultMessage: 'None',
		description:
			'Text used as a group name for empty user field values when grouping items by user fields is enabled.',
	},
	anonymousDisplayName: {
		// TODO: [JSC-2233] remove nonfinal suffix after confirming with CD
		id: 'issue-table-grouping.group-row.group-header.user-group-header.anonymous-display-name-nonfinal',
		defaultMessage: 'Anonymous',
		description:
			'Text used as a group name for anonymous issues when grouping items by assignee is enabled.',
	},
});
